export default {
  utility: {
    title: 'Introduction',
    titleP1:`
    In order to facilitate users to perform pre- and post-processing of calculations,
    the PWmat installation package comes with a series of utilities.
    Through these programs, we can realize the conversion between PWmat structure files and other
    common crystal structure files, process data to obtain visualized charge density,
    band structure diagram, projected state density, vacuum energy level and other operations.
    `,
    titleP2: 'To use all the utilities, you only need to load the PWmat environment, as follows (source code attached):',
    titlePre01: `
#Users who have installed PWmat and configured environment variables can
#directly use the corresponding program (taking the processing of band structure diagram as an example):`,
    titlePre02: `
#Users who have not installed PWmat need to load the PWmat environment
#before using the corresponding program (taking the processing of the band structure diagram as an example):`,
    title2: 'Download Link',
    menu1: 'Format Conversion',
    menu2: 'Data Visualization',
    menu3: 'Data post-processing',
    tableR0C1: 'name',
    tableR0C2: 'Introduction',
  }
}